import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://wccnqdvdljsocfciklur.supabase.co";
const SUPABASE_KEY = "sb_publishable_7h3hRqYh-2i8yqRZlJ-3SA_iBtZXhAA";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
